import { render, staticRenderFns } from "./GroupChatTopBar.vue?vue&type=template&id=488fb265&"
import script from "./GroupChatTopBar.vue?vue&type=script&lang=js&"
export * from "./GroupChatTopBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatTopBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports